.textContrastColor {
  color: var(--colors-text-inverse);
}
